import { API_URL } from '../../constant/API_Settings';

function authHeaders(json = true) {
  const headers = {
    Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
    Accept: 'application/json',
  };
  if (json) {
    headers['Content-Type'] = 'application/json';
  }
  return headers;
}

async function parseJson(response) {
  let data = {};
  try {
    data = await response.json();
  } catch {
    // ignore
  }
  if (!response.ok) {
    throw new Error(data.message || `Request failed (${response.status})`);
  }
  return data;
}

export function fetchSupportMeta() {
  return fetch(`${API_URL}/support/meta`, { headers: authHeaders() }).then(parseJson);
}

export function searchSupportFaq(query) {
  const params = new URLSearchParams();
  if (query) params.set('q', query);
  return fetch(`${API_URL}/support/faq?${params}`, { headers: authHeaders() }).then(parseJson);
}

export function fetchMySupportTickets(status = '') {
  const params = new URLSearchParams();
  if (status) params.set('status', status);
  return fetch(`${API_URL}/support/tickets?${params}`, { headers: authHeaders() }).then(parseJson);
}

export function fetchSupportTicketDetail(ticketId) {
  return fetch(`${API_URL}/support/tickets/${ticketId}`, { headers: authHeaders() }).then(parseJson);
}

export function createSupportTicket(payload, files = []) {
  const hasFiles = Array.isArray(files) && files.length > 0;
  if (!hasFiles) {
    return fetch(`${API_URL}/support/tickets`, {
      method: 'POST',
      headers: authHeaders(),
      body: JSON.stringify(payload),
    }).then(parseJson);
  }

  const formData = new FormData();
  Object.keys(payload || {}).forEach((key) => {
    if (payload[key] !== null && payload[key] !== undefined && payload[key] !== '') {
      formData.append(key, payload[key]);
    }
  });
  files.forEach((file) => formData.append('attachments[]', file));

  return fetch(`${API_URL}/support/tickets`, {
    method: 'POST',
    headers: authHeaders(false),
    body: formData,
  }).then(parseJson);
}

export function replySupportTicket(ticketId, message) {
  return fetch(`${API_URL}/support/tickets/${ticketId}/messages`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ message }),
  }).then(parseJson);
}

export function downloadSupportAttachment(ticketId, attachmentId, asAdmin = false) {
  const base = asAdmin
    ? `${API_URL}/admin/support/tickets/${ticketId}/attachments/${attachmentId}/download`
    : `${API_URL}/support/tickets/${ticketId}/attachments/${attachmentId}/download`;

  return fetch(base, {
    headers: {
      Authorization: 'Bearer ' + localStorage.getItem('AUTH_TOKEN'),
    },
  }).then(async (response) => {
    if (!response.ok) {
      let message = `Download failed (${response.status})`;
      try {
        const data = await response.json();
        message = data.message || message;
      } catch {
        // ignore
      }
      throw new Error(message);
    }
    const blob = await response.blob();
    const disposition = response.headers.get('Content-Disposition') || '';
    const match = /filename="?([^"]+)"?/i.exec(disposition);
    const filename = match ? match[1] : `attachment-${attachmentId}`;
    return { blob, filename };
  });
}

export function adminDeleteSupportAttachment(ticketId, attachmentId) {
  return fetch(`${API_URL}/admin/support/tickets/${ticketId}/attachments/${attachmentId}`, {
    method: 'DELETE',
    headers: authHeaders(),
  }).then(parseJson);
}

export function fetchAdminSupportTickets(filters = {}) {
  const params = new URLSearchParams();
  if (filters.status) params.set('status', filters.status);
  if (filters.priority) params.set('priority', filters.priority);
  if (filters.category) params.set('category', filters.category);
  if (filters.search) params.set('search', filters.search);
  if (filters.page) params.set('page', String(filters.page));
  return fetch(`${API_URL}/admin/support/tickets?${params}`, { headers: authHeaders() }).then(parseJson);
}

export function fetchAdminSupportTicketDetail(ticketId) {
  return fetch(`${API_URL}/admin/support/tickets/${ticketId}`, { headers: authHeaders() }).then(parseJson);
}

export function adminReplySupportTicket(ticketId, message, status) {
  return fetch(`${API_URL}/admin/support/tickets/${ticketId}/reply`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ message, status }),
  }).then(parseJson);
}

export function adminUpdateSupportTicketStatus(ticketId, status) {
  return fetch(`${API_URL}/admin/support/tickets/${ticketId}/status`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify({ status }),
  }).then(parseJson);
}

export function adminCreateSupportTicket(payload) {
  return fetch(`${API_URL}/admin/support/tickets`, {
    method: 'POST',
    headers: authHeaders(),
    body: JSON.stringify(payload),
  }).then(parseJson);
}

export async function saveBlobAsFile(blob, filename) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = filename || 'download';
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}
